import { LucideIcon } from 'lucide-react';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

import { FilterOptionsPanel } from './FilterOptionsPanel';
import { FilterPill } from './FilterPill';
import { FILTER_SUBMENU_WIDTH } from './filterStyles';
import { FilterInputType, FilterOption } from './types';

interface FilterPillPopoverProps {
  icon: LucideIcon;
  title: string;
  text: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onRemove: () => void;
  filterDefinition: {
    overlayLabel?: string;
    type: FilterInputType;
    options: FilterOption[];
    placeholder?: string;
    condition?: boolean;
  };
  value?: string | string[];
  onValueChange: (value: string | string[] | undefined, exclude?: boolean) => void;
  exclude?: boolean;
  isSelectOpen: boolean;
  onSelectOpenChange: (open: boolean) => void;
  /** Show the "Clear · All" bulk actions for checkbox filters. Defaults to true. */
  showBulkActions?: boolean;
}

export const FilterPillPopover = ({
  icon,
  title,
  text,
  isOpen,
  onOpenChange,
  onRemove,
  filterDefinition,
  value,
  onValueChange,
  exclude,
  isSelectOpen,
  onSelectOpenChange,
  showBulkActions,
}: FilterPillPopoverProps) => {
  const { overlayLabel, type, options, placeholder, condition } = filterDefinition;

  return (
    <Popover
      open={isOpen}
      onOpenChange={(nextOpen) => {
        if (!nextOpen && isSelectOpen) {
          return;
        }
        onOpenChange(nextOpen);
      }}
    >
      <PopoverTrigger asChild>
        <FilterPill
          icon={icon}
          title={title}
          text={text}
          onClose={onRemove}
          isActive={isOpen}
          className="cursor-pointer"
        />
      </PopoverTrigger>
      <PopoverContent
        className={cn(FILTER_SUBMENU_WIDTH, 'p-0')}
        align="start"
        sideOffset={8}
        onInteractOutside={(e) => {
          if (isSelectOpen) {
            e.preventDefault();
          }
        }}
      >
        <FilterOptionsPanel
          title={overlayLabel || title}
          type={type}
          options={options}
          placeholder={placeholder}
          condition={condition}
          value={value}
          onValueChange={onValueChange}
          exclude={exclude}
          onBack={() => onOpenChange(false)}
          onSelectOpenChange={onSelectOpenChange}
          showBulkActions={showBulkActions}
        />
      </PopoverContent>
    </Popover>
  );
};
